'use client';
import SlideOver from '../Slideover';
import { NavigationItem, NavigationMenu } from './NavigationMenu';

export interface MainNavigationProps {
  open: boolean;
  onClose: (open: boolean) => void;
}

const navigationItems: NavigationItem[] = [
  {
    label: 'Fiona Posts',
    children: [
      {
        label: 'Properties',
        href: '/dashboard',
      },
      {
        label: 'Posts Error Report',
        href: '/posts-errors-report',
        protectWith: ['SYSTEM:ADMIN', 'AGENCY:USER'],
      },
      {
        label: 'Media Report',
        href: '/media-report',
      },
    ],
  },
  {
    label: 'Reporting',
    flags: ['portfolio-dashboard-access'],
    children: [
      {
        label: 'Portfolio Health',
        href: '/pmc/portfolio',
        protectWith: ['SYSTEM:ADMIN', 'AGENCY:USER'],
      },
    ],
  },
  {
    label: 'Agency Onboarding',
    href: '/onboarding',
    protectWith: ['SYSTEM:ADMIN', 'AGENCY:USER'],
  },
  {
    label: 'Optimization Notes',
    href: '/optimization-notes',
    protectWith: ['SYSTEM:ADMIN', 'AGENCY:USER'],
    flags: ['optimization-notes'],
  },
];

export function MainNavigation({ open, onClose }: MainNavigationProps) {
  return (
    <SlideOver
      open={open}
      title="Navigation"
      onClose={onClose}
      hideHeaderDivider
      width="small"
      position="left"
    >
      <NavigationMenu items={navigationItems} onNavigate={() => onClose(false)} />
    </SlideOver>
  );
}
